
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/benefits-directory",
      function () {
        return require("private-next-pages/benefits-directory.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/benefits-directory"])
      });
    }
  